export enum FirestoreQueryType {
    UNKNOWN,
    WHERE,
    ORDERBY,
    LIMIT,
    STARTAT,
    ENDAT,
    STARTAFTER,
    ARRAYCONTAINS
}